import React, {CSSProperties} from 'react';
import { GrDrag } from 'react-icons/gr';
import './outlineContainerDrag.scss'

export interface OutlineContainerDragProps {
  provided?: any
  title?: string
  className?: string
  style?: CSSProperties
  children?: any
  id?: string
}

const OutlineContainerDrag: React.SFC<OutlineContainerDragProps> = (props) => {
  return (
    <div
      className={`outline_container_drag-layout ${props.className ? props.className : ''}`}
      style={props.style}
      id={props.id}
    >
      <div
        className="title_item-drag"
      >
        {props.provided ?
          <div
            {...props.provided.dragHandleProps}
          >
            <GrDrag
              className='icon-drag-item'
            />
          </div>
        : null}
        <p>{props.title}</p>
      </div>
      {props.children}
    </div>
  );
}

export default OutlineContainerDrag;
